<div class="row">
    <div class="col-md-12">
        <h2>Pending Transactions</h2>
        <p class="text-muted">These are transactions that were processed using carrier credit and are pending actual payment from the carrier.</p>
    </div>
</div>

<div class="row align-items-end">
    <div class="col-md-8">
        <div class="row">
            <div class="col-md-6">
                <mt-dynamic-search-filters [config]="dynamicSearchFiltersConfig" (searchValuesUpdated)="search($event)"></mt-dynamic-search-filters>
            </div>
            <div class="col-md-6">
                <mt-search-filter-daterange
                    *ngIf="datepickerEntityName"
                    [entity]="datepickerEntityName"
                    [startDate]="startDate"
                    [endDate]="endDate"
                    (selectionChanged)="dateSelectionChanged($event)"
                ></mt-search-filter-daterange>
            </div>
        </div>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn-success" (click)="exportToExcel()" [disabled]="pendingTransactions.length === 0">
            <i class="fa fa-file-excel-o"></i> Export to Excel
        </button>
    </div>
</div>

<br>
<mt-entity-list 
    *ngIf="pendingTransactions && entityListConfig"
    [entities]="pendingTransactions" 
    [total]="total" 
    [(currentPage)]="currentPage" 
    [(itemsPerPage)]="itemsPerPage"
    (pageChanged)="pageChanged()" 
    (columnSortedEvent)="columnSorted($event)"
    (selectionChangedEvent)="selectionChanged($event)"
    [selectedEntities]="selectedEntities"
    [entityListConfig]="entityListConfig"
>
